(function() {
	'use strict';

	angular
		.module('assetCommon')
		.directive('dragDropMonitor', dragDropMonitor)
		.directive('dragDropDropTarget', dragDropDropTarget);

	var dragStatusEventName = 'dragdrop.window.dragging';

	function dragDropMonitor($timeout) {
		return {
			restrict: 'A',
			controller: ['$scope', function ($scope) {
				var vm = this;
				var currentDragOverTarget;

				$scope.dragOver = false;
				$scope.showDragDropOutline = false;

				vm.shouldShowDragDropOutline = function (show) {
					$scope.showDragDropOutline = show;
				};

				vm.setDragOver = function (targetElement, over) {
					if (over) {
						currentDragOverTarget = targetElement;
						$scope.dragOver = over;
					}
					else if (currentDragOverTarget === targetElement) {
						$scope.dragOver = false;
					}
					else {
						currentDragOverTarget = null;
					}
				};
				vm.setIsDragOverDropTarget = function (targetElement, value) {
					if (value) {
						currentDragOverTarget = targetElement;
						$scope.isDragOverDropTarget = true;
					}
					else if (currentDragOverTarget === targetElement) {
						$scope.isDragOverDropTarget = false;
					}
					else {
						currentDragOverTarget = null;
					}
				};
			}],
			link: function (scope, elem, attrs) {
				var timer;
				var isDragging = false;

				function broadcastStatus() {
					scope.$broadcast(dragStatusEventName, { isDragging: isDragging });
				}

				elem.on('dragover', function (e) {
					if (!scope.$eval(attrs.dragEnabled))
						return;

					e.stopPropagation();
					e.preventDefault();

					if (!scope.isDragOverDropTarget)
						e.originalEvent.dataTransfer.dropEffect = 'none';

					if (isDragging) {
						$timeout.cancel(timer);
					}
					else {
						scope.$apply(function () {
							isDragging = true;
							scope.showDragDropOutline = true;
						});
						broadcastStatus();
					}

					timer = $timeout(function () {
						isDragging = false;
						scope.showDragDropOutline = false;
						broadcastStatus();
					}, 100);
				});
			}
		};
	}
	dragDropMonitor.$inject = ['$timeout'];

	function dragDropDropTarget($rootScope, $parse, _, mimeTypeUtility, assetCommonConfig) {
		var dropEventName = assetCommonConfig.dropEventName;

		function areValidFileTypes(fileTypes, acceptedFileTypes) {
			if (!acceptedFileTypes || acceptedFileTypes.length === 0)
				return true;

			var acceptedTypes = _.map(acceptedFileTypes, function(type) {
				return mimeTypeUtility.splitMimeType(type);
			});

			return _.all(fileTypes, function (fileType) {
				var fileTypeResult = mimeTypeUtility.splitMimeType(fileType);
				return _.all(acceptedTypes, function(acceptedType) {
					return fileTypeResult.type === acceptedType.type && (acceptedType.subType === '*' || acceptedType.subType === fileTypeResult.subType);
				});
			});
		}

		return {
			restrict: 'A',
			require: '^dragDropMonitor',
			link: function (scope, elem, attrs, dragDropController) {
				var dataTransferEffect = attrs.datatransferEffect;
				var dragOutTimer;

				var callback = attrs.dropAction && $parse(attrs.dropAction);

				elem.on({
					'dragover dragenter': function (e) {
						var dataTransfer = e.originalEvent.dataTransfer;
						var isAllowed = _.contains(dataTransfer.types, 'Files') && areValidFileTypes(_.pluck(dataTransfer.items, 'type'), attrs.acceptedFiles ? attrs.acceptedFiles.split(',') : null);

						dataTransfer.dropEffect = isAllowed ? dataTransferEffect : 'none';

						if (scope.isDragOver) {
							window.clearTimeout(dragOutTimer);
						}
						else {
							scope.$apply(function () {
								var over = attrs.over;
								if (over) {
									dragDropController.setDragOver(elem, over);
									dragDropController.shouldShowDragDropOutline(false);
								}
								dragDropController.setIsDragOverDropTarget(elem, true);
								scope.isDragOver = true;
							});
						}

						dragOutTimer = window.setTimeout(function () {
							scope.$apply(function () {
								scope.isDragOver = false;
								dragDropController.setIsDragOverDropTarget(elem, false);
							});
						}, 100);
					},
					'dragleave': function () {
						if (attrs.over) {
							scope.$apply(function () {
								dragDropController.setDragOver(elem, false);
								dragDropController.shouldShowDragDropOutline(true);
							});
						}

						scope.$apply(function () {
							scope.isDragOver = false;
							dragDropController.setIsDragOverDropTarget(elem, false);
						});
					},
					'drop': function (e) {
						e.stopPropagation();
						e.preventDefault();

						var files = e.originalEvent.dataTransfer.files;

						if (!callback) {
							$rootScope.$broadcast(dropEventName, { files: files });
						}
						else {
							scope.$apply(function () {
								callback(scope, { files: files });
							});
						}
					}
				});

				scope.$on(dragStatusEventName, function (event, status) {
					scope.$apply(function () {
						scope.isDragging = status.isDragging;
					});
				});
			}
		};
	}
	dragDropDropTarget.$inject = ['$rootScope', '$parse', '_', 'mimeTypeUtility', 'assetCommonConfig'];
})();